import { Mail, Phone, MapPin, Instagram } from "lucide-react";
import { FadeUp } from "../components/Motion";
import { CONTACT } from "../data/content";

const Footer = () => (
  <footer id="contact" data-testid="footer" className="bg-[#050505] border-t border-white/10 pt-28 md:pt-40 pb-12">
    <div className="mx-auto max-w-[1600px] px-6 md:px-12">
      <FadeUp>
        <a
          data-testid="footer-email-link"
          href={`mailto:${CONTACT.email}`}
          className="block font-serif text-[13vw] md:text-[10vw] leading-[0.9] tracking-tighter hover:text-[#F5A623] transition-colors duration-500"
        >
          Let's <span className="italic">talk</span>.
        </a>
      </FadeUp>

      <div className="mt-20 grid grid-cols-1 md:grid-cols-4 gap-10 border-t border-white/10 pt-12">
        <a data-testid="contact-email" href={`mailto:${CONTACT.email}`} className="group">
          <div className="flex items-center gap-2 text-[#F5A623] text-xs uppercase tracking-[0.2em] mb-3">
            <Mail size={14} /> Email
          </div>
          <p className="text-white group-hover:text-[#F5A623] transition-colors duration-300 text-sm sm:text-base whitespace-nowrap">{CONTACT.email}</p>
        </a>

        <a data-testid="contact-phone" href={CONTACT.phoneHref} className="group">
          <div className="flex items-center gap-2 text-[#F5A623] text-xs uppercase tracking-[0.2em] mb-3">
            <Phone size={14} /> Phone
          </div>
          <p className="text-white group-hover:text-[#F5A623] transition-colors duration-300">{CONTACT.phone}</p>
        </a>

        <div data-testid="contact-location">
          <div className="flex items-center gap-2 text-[#F5A623] text-xs uppercase tracking-[0.2em] mb-3">
            <MapPin size={14} /> Studio
          </div>
          <p className="text-white">{CONTACT.location}</p>
        </div>

        <a data-testid="contact-instagram" href={CONTACT.instagramHref} target="_blank" rel="noopener noreferrer" className="group">
          <div className="flex items-center gap-2 text-[#F5A623] text-xs uppercase tracking-[0.2em] mb-3">
            <Instagram size={14} /> Instagram
          </div>
          <p className="text-white group-hover:text-[#F5A623] transition-colors duration-300">{CONTACT.instagram}</p>
        </a>
      </div>

      <div className="mt-20 flex flex-col md:flex-row items-center justify-between gap-4 text-[#52525B] text-sm">
        <div className="flex items-center gap-3">
          <img src={CONTACT.logo} alt="RLP Photography and Production logo" className="h-[5.5rem] w-auto rounded-md" />
        </div>
        <p>© {new Date().getFullYear()} RLP Photography · San Antonio, Texas</p>
      </div>
    </div>
  </footer>
);

export default Footer;
